import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

export default createServiceProvider({
  ...getServiceProvider('recharge'),
  titleToNamespace: true,
  experimental: false,
  hasConnectionStatus: false,
  avatarPath: avatars.recharge,
  logoPath: logos.recharge
});
